import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRatingStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "rating-star" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.533,1.571a.5.5,0,0,1,.936,0L15,8.747h7.148a.5.5,0,0,1,.325.88L16.5,14.579l2.5,7.51a.5.5,0,0,1-.77.561L12,18.079,5.767,22.65A.5.5,0,0,1,5,22.089l2.5-7.51L1.526,9.627a.5.5,0,0,1,.325-.88H9Z"
		})
	]
});
export default SvgRatingStar;
